import type { UUID } from '@/types/Id'
import type { MemoryTarget } from '@/types/Memory'

const targetIdOrNull = (id: string | null | undefined) => id || null

export const memoryKeys = {
  all: ['memories'] as const,
  lists: ['memories', 'list'] as const,
  usage: ['memories', 'usage'] as const,
  count: (organizationId: UUID | '') =>
    ['memories', 'count', organizationId] as const,
  target: (target: MemoryTarget) =>
    [
      'memories',
      'list',
      target.scope_kind,
      target.organization_id,
      targetIdOrNull(target.pursuit_id),
      targetIdOrNull(target.file_id),
    ] as const,
  suggestions: (target: MemoryTarget) =>
    [
      'memory-suggestions',
      target.scope_kind,
      target.organization_id,
      targetIdOrNull(target.pursuit_id),
      targetIdOrNull(target.file_id),
    ] as const,
  allSuggestions: ['memory-suggestions'] as const,
  activity: (memoryId: UUID | '') => ['memory', memoryId, 'activity'] as const,
}

export const isMemoryTargetReady = (target: MemoryTarget): boolean => {
  if (!target.organization_id) {
    return false
  }

  switch (target.scope_kind) {
    case 'organization':
      return true
    case 'pursuit':
      return !!target.pursuit_id
    case 'file':
      return !!target.file_id
  }
}
